<!-- Teo connection with Online info -->
<template>
  <div class="text-muted container">
    <small>
      <div class="name">id: {{ teoname }}</div>
      <div class="name">server: {{ name }}</div>
      <div class="uptime">uptime: {{ uptime }}</div>
      <div class="version">version: {{ version }}</div>
      <div class="clients">clients: {{ clients }}</div>
      <div>
        <a class="online" v-if="online" href="./">online</a>
        <a class="offline" v-else  href="./">offline</a>
        <span v-if="connectType" @click="setConnectType()">
          [{{ connectType }}]</span
        >
      </div>
      <button
        v-if="disconnected"
        type="button"
        class="btn btn-sm btn-warning mt-2 mb-2"
        @click="reconnect()"
      >
        Reconnect
      </button>
    </small>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";

// Defalut teoweb commands
const cmdClients = "clients";

// This application teoweb commands
const cmdName = "name";
const cmdUptime = "uptime";
const cmdVersion = "version";
const cmdLoginUserSet = "login.user.set";

export default {
  name: "TeoWeb",

  emits: ["online"],

  data() {
    return {
      name: "Loading ...",
      teoname: "Loading ...",
      uptime: "0",
      version: "...",
      clients: "0",
      connectType: "",
      online: false,
      disconnected: false,
    };
  },

  mounted: function () {
    this.connect();
    this.connectType = this.teoweb.connectType;
  },

  unmounted: function () {
    this.teoweb.delReader(this.reader);
  },

  methods: {
    setConnectType() {
      if (this.connectType == "ws") {
        this.connectType = "webrtc";
      } else {
        this.connectType = "ws";
      }

      localStorage.setItem("connectType", this.connectType);
      this.reset(this.connectType);
      this.connect();
    },

    /** Connect to Teonet server. */
    connect() {
      const connectType = this.teoweb.connectType;
      const that = this;

      // Get this browser name from local storage
      this.teoname = uuid.v1();
      console.debug("teoname:", this.teoname);

      // Get name and version from local storage
      if (localStorage.name) this.name = localStorage.name;
      if (localStorage.version) this.version = localStorage.version;

      // Connect to Teonet proxy WebRTC server

      // Webrtc Server name
      // The server_name is defined in global variable server_name.
      // The server_name stored in server_name_sample.js file.
      // To change server_name copy file server_name_sample.js to server_name.js
      // and update the server_name constant.
      const serverName =
        connectType == "ws" ? this.server_name_ws : this.server_name;

      console.debug("server name:", serverName);

      // This server scheme, host and path
      const scheme = "wss";
      const path = connectType == "ws" ? "/ws" : "/signal";
      const host =
        connectType == "ws" ? "fortune-gui.teonet.dev" : "signal.teonet.dev";

      // Connect to Teonet proxy WebRTC or WebSocket server
      this.teoweb.connect(
        scheme + "://" + host + path,
        this.teoname,
        serverName
      );

      // Listen for WebRTC on open event
      this.teoweb.onOpen(function () {
        console.debug("connect onopen");

        // Set online
        that.online = true;
        that.disconnected = false;

        // Send emit online event
        that.$emit("online", true);

        // Set login information
        let userkey = localStorage.userkey || sessionStorage.userkey;
        that.teoweb.sendCmd(cmdLoginUserSet, userkey);

        // Request connect component data from WebRTC server
        that.teoweb.sendCmd(cmdName);
        that.teoweb.sendCmd(cmdUptime);
        that.teoweb.sendCmd(cmdVersion);
        that.teoweb.sendCmd(cmdClients);
        that.teoweb.subscribeCmd(cmdClients);
      });

      // Listen for WebRTC on close event
      this.teoweb.onClose(function (b) {
        console.debug("connect onclose");

        // Set offline
        that.online = false;
        if (b === true) {
          that.disconnected = true;
          // that.reconnect();
        }

        // Send emit online event
        that.$emit("online", false);
      });

      // Listen for WebRTC data from server
      this.teoweb.addReader(function (gw, data) {
        switch (gw.command) {
          case cmdClients:
            that.clients = data;
            break;

          case cmdName:
            that.name = data;
            localStorage.name = that.name;
            break;

          case cmdVersion:
            that.version = data;
            localStorage.version = that.version;
            break;

          case cmdUptime:
            that.uptime = data;
            break;

          case cmdLoginUserSet:
            that.teoweb.token = data;
            console.debug("logged in");
            break;
        }
      });
    },

    /** Reconnect to Teonet server */
    reconnect() {
      // TODO: Implement reconnect or Update teoweb
      location.reload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.online {
  color: #42b983 !important;
}
.offline {
  color: red !important;
}

.online,
.offline {
  text-decoration: none;
}

.connectType {
  color: #ffc107;
}
</style>
